export default "__VITE_ASSET__D$GqzyAr__"